const carouselItems = [
  {
    id: 1,
    title: '暑期档 · 国剧盛典',
    desc: '百部经典国产剧一次性放送，从《琅琊榜》到《狂飙》，回顾国剧二十年辉煌历程。暑期追剧不剧荒，总有一部适合你。',
    tag: '专题合集',
    img: 'https://readdy.ai/api/search-image?query=Warm%20cinematic%20collage%20of%20classic%20Chinese%20TV%20drama%20moments%2C%20golden%20film%20strip%20border%2C%20vintage%20theater%20curtain%20texture%2C%20dramatic%20warm%20lighting%2C%20amber%20spotlight%20effect%2C%20artistic%20composition&width=800&height=500&seq=carousel-01&orientation=landscape'
  },
  {
    id: 2,
    title: '悬疑剧场 · 烧脑特辑',
    desc: '从《隐秘的角落》到《漫长的季节》，精选50部高分悬疑剧。反转再反转，每一部都让你猜到最后一秒。',
    tag: '悬疑',
    img: 'https://readdy.ai/api/search-image?query=Dark%20moody%20detective%20office%20with%20warm%20desk%20lamp%20glow%2C%20evidence%20board%20with%20red%20strings%2C%20rain%20on%20window%2C%20noir%20atmosphere%2C%20cinematic%20lighting%2C%20amber%20and%20deep%20shadow%20contrast&width=800&height=500&seq=carousel-02&orientation=landscape'
  },
  {
    id: 3,
    title: '古装权谋 · 朝堂风云',
    desc: '《庆余年》《琅琊榜》《长安十二时辰》等经典古装权谋剧全收录。步步为营的权谋博弈，带你领略古代朝堂的智慧较量。',
    tag: '古装',
    img: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20imperial%20throne%20room%20with%20warm%20candlelight%2C%20ornate%20dragon%20pillars%2C%20dramatic%20light%20shafts%20through%20lattice%20windows%2C%20golden%20amber%20glow%2C%20cinematic%20grandeur&width=800&height=500&seq=carousel-03&orientation=landscape'
  },
  {
    id: 4,
    title: '新剧速递 · 即将上线',
    desc: '2025下半年最受期待的新剧预告合集。各大平台重磅新作独家前瞻，预约追剧不迷路，第一时间锁定最热新剧。',
    tag: '新剧',
    img: 'https://readdy.ai/api/search-image?query=Modern%20cinema%20marquee%20with%20warm%20neon%20glow%2C%20coming%20soon%20posters%20on%20display%2C%20excited%20silhouettes%20below%2C%20evening%20atmosphere%2C%20golden%20hour%20lighting%2C%20cinematic%20street%20scene&width=800&height=500&seq=carousel-04&orientation=landscape'
  },
];

export default function Carousel() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
            焦点专题
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            精选专题合集，一站直达你最想看的精彩内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {carouselItems.map((item) => (
            <div
              key={item.id}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-accent-300/50 transition-all cursor-pointer"
            >
              <div className="relative aspect-[8/5] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 bg-accent-500 text-white text-xs rounded-full">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-medium text-foreground-800 mb-2">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}